// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"2a022a90","583":"7f545378"}[chunkId] + ".chunk.js";
};